<template>
  <div>
    <div ref="mindmap" class="mindmap-container" />
  </div>
</template>

<script>
import MindMap from 'simple-mind-map';
export default {
  mounted() {
    const mindmap = new MindMap({
      el: this.$refs.mindmap,
      data: {
        text: '中心主题',
        children: [
          { text: '主题1' },
          { text: '主题2' },
          {
            text: '主题3',
            children: [{ text: '子主题3-1' }, { text: '子主题3-2' }]
          }
        ]
      }
    });
  }
};
</script>

<style lang="less" scoped>
#mindMapContainer * {
  margin: 0;
  padding: 0;
}

/* 添加样式确保思维导图正常显示 */
.mindmap-container {
  width: 100%;
  height: 100vh;
}
</style>
